import {FC} from 'react'

const Error500: FC = () => {
  return (
    <div style={{ marginTop: '10%' }}>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Hệ thống đang bảo trì</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        Hệ thống đang trong giai đoạn bảo trì<br /> Vui lòng thử lại sau.
      </div>
    </div>
  )
}

export {Error500}
